// extracted by mini-css-extract-plugin
module.exports = {"AvatarIconContainer":"avatar_AvatarIconContainer__1qz02","AvatarIconShadow":"avatar_AvatarIconShadow__UQ4yP","AvatarIcon":"avatar_AvatarIcon__27BZA"};